import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { requestApi } from "../../../request-api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import Dropdown from "../../layouts/dropdown/Dropdown";
import ActDropdown from "../../layouts/dropdown/ActDropdown";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { API_URL } from "../../../config";
import exportIcon from "../../../assets/image/document-download.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { isLocalDateInRange } from "../../../helpers/complianceDashboard";



function Active() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [companySearchName, setCompanySearchName] = useState("");
  const [locationSearchName, setLocationSearchName] = useState("");
  const [companies, setCompanies] = useState([]);
  const dateDropdownRef = useRef(null);
  const [locations, setLocations] = useState([]);
  const [activeFilter, setActiveFilter] = useState("This Month");
  const [sortBy, setSortBy] = useState("none");
  const [selectedAct, setSelectedAct] = useState([]);
  const [actSearchName, setActSearchName] = useState("");
  const [compliance, setCompliance] = useState([]);
  const [format, setFormat] = useState("pdf");
  const [selectedSubBranch, setSelectedSubBranch] = useState([]);
  const [subBranches, setSubBranches] = useState([]);
  const [selectedSubBranches, setSelectedSubBranches] = useState([]);
  const [availableSubBranches, setAvailableSubBranches] = useState([]);
  const [availableActs, setActs] = useState([]);
  const [period, setPeriod] = useState("Monthly");
  const dropdownRef2 = useRef(null);
  const [showDropdown1, setShowDropdown1] = useState(false);

  useEffect(() => {
    if (location?.state) {
      const {
        status,
        selectedStatus: passedStatus,
        selectedCompany: passedCompany,
        selectedLocation: passedLoc,
        filterDateWise: passedDateWise,
        activeFilter: passedActiveFilter,
        applyDateFilter,
      } = location.state;

      if (passedStatus && passedStatus.length > 0) {
        setSelectedStatus(passedStatus);
      } else if (status) {
        setSelectedStatus([status]);
      }

      if (passedCompany && (Array.isArray(passedCompany) ? passedCompany.length > 0 : Boolean(passedCompany))) {
        setSelectedCompany(passedCompany);
      } else {
        setSelectedCompany("");
      }

      if (passedLoc && (Array.isArray(passedLoc) ? passedLoc.length > 0 : Boolean(passedLoc))) {
        setSelectedLocation(passedLoc);
      } else {
        setSelectedLocation("");
      }

      if (applyDateFilter && passedDateWise && passedDateWise.startDate && passedDateWise.endDate) {
        setFilterDateWise({
          startDate: new Date(passedDateWise.startDate),
          endDate: new Date(passedDateWise.endDate),
        });
        if (passedActiveFilter) {
          setActiveFilter(passedActiveFilter);
        }
      } else {
        setFilterDateWise({
          startDate: null,
          endDate: null,
        });
        setActiveFilter("");
      }
    }
  }, [location?.state]);
  
  // Initialize with current month dates
  const getCurrentMonthDates = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  };

  const { start: defaultStart, end: defaultEnd } = getCurrentMonthDates();
  const [filterDateWise, setFilterDateWise] = useState({
    startDate: defaultStart,
    endDate: defaultEnd,
  });
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [bulkFormData, setBulkFormData] = useState({
    accepted: false,
    comment: "",
  });

  const statusOptions = [
  "Complied",
  "Not Complied",
  "Partial Complied",
  "Not Applicable",
  "Not Updated",
];


  const [isOpen4, setIsOpen4] = useState(false);
  const dropdownRef1 = useRef(null);
  const [columns, setColumns] = useState([
    { id: "select", key: "select", label: "Select", visible: true },
    { id: "srno", key: "id", label: "Sr No", visible: true },
    { id: "entity", key: "company_name", label: "Entity", visible: true },
    { id: "branch", key: "branch_id", label: "Branch ID", visible: true },
    { id: "act", key: "legislation_name", label: "Act", visible: true },
    { id: "comp_desc", key: "compd", label: "Compliance Description", visible: true },
    { id: "date_of_comp", key: "period", label: "Date of Compliance", visible: true },
    { id: "due_date", key: "due_date", label: "Due Date", visible: true },
    { id: "officer", key: "assigned_compliance_officer", label: "Compliance Officer", visible: true },
    { id: "approver", key: "assigned_approver", label: "Approver", visible: true },
    { id: "status", key: "curr", label: "Status", visible: true },
    { id: "action", key: "action", label: "Action", visible: true },
  ]);

  const toggleDropdown1 = () => {
  setShowDropdown1((prev) => !prev);
};

   useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setShowDropdown1(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

     useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            dateDropdownRef.current &&
            !dateDropdownRef.current.contains(event.target)
          ) {
            setIsOpen(false);
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setIsOpen4(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const formats = [
    { label: "Pdf", icon: "bi-file-earmark-pdf", value: "pdf" },
    { label: "Excel", icon: "bi-file-earmark-excel", value: "excel" },
  ];
  const periods = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
  const [formData, setFormData] = useState({
    accepted: "",
    comment: "",
  });
  useEffect(() => {
  if (compliance) {
    setFormData({
      accepted: compliance.verify_report === 1, // ✅ checked if 1
      comment: compliance.comment || "",
    });
  }
}, [compliance]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredReports.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredReports.length / itemsPerPage);
  const visiblePages = 5;
  const dropdownRef = useRef(null);
  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = startPage + visiblePages - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - visiblePages + 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  useEffect(() => {
    fetchReports();
  }, []);

  useEffect(() => {
    let filtered = [...reports];

    // Apply date filter
    if (filterDateWise.startDate && filterDateWise.endDate) {
      filtered = filtered.filter((item) =>
        isLocalDateInRange(item.due_date, filterDateWise.startDate, filterDateWise.endDate)
      );
    }

    if (selectedAct.length > 0) {
      filtered = filtered.filter((item) =>
        selectedAct.includes(item.legislation_name)
      );
    }
    if (selectedCompany.length > 0 || selectedLocation.length > 0) {
      filtered = filtered.filter((item) => {
        const matchesCompany =
          selectedCompany.length === 0 ||
          selectedCompany.includes(item.company_name);
        const matchesLocation =
          selectedLocation.length === 0 ||
          selectedLocation.includes(item.location);
        return matchesCompany && matchesLocation;
      });
    }
    if (selectedSubBranch.length > 0) {
      filtered = filtered.filter((item) =>
        selectedSubBranch.includes(item.sub_branch)
      );
    }

    if (selectedStatus.length > 0) {
  filtered = filtered.filter((item) =>
    selectedStatus.includes(item.curr)
  );
}


    if (sortBy !== "none") {
      filtered = sortReports(filtered, sortBy);
    }

    setFilteredReports(filtered);
    setCurrentPage(1);
  }, [
    reports,
    filterDateWise,
    selectedAct,
    selectedCompany,
    selectedLocation,
    selectedSubBranch,
    selectedStatus,
    sortBy,
  ]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const fetchReports = async () => {
    setLoading(true);

    try {
      const res = await requestApi(`/report/fetch/by-auditor`, {
        method: "get",
      });

      const reports = res.data;

      const _companies = [...new Set(reports.map((r) => r.company_name))];
      const _locations = [...new Set(reports.map((r) => r.location))];
      const uniqueActs = [
        ...new Set(reports.map((r) => r.legislation_name).filter(Boolean)),
      ];
      const _subBranches = [
        ...new Set(reports.map((r) => r.sub_branch).filter(Boolean)),
      ];

      setCompanies(_companies);
      setLocations(_locations);
      setActs(uniqueActs);
      setSubBranches(_subBranches);
      setReports(reports);
    } catch (err) {
      toast.error(err?.data || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const toggleCompanySelection = (item) => {
    setSelectedCompany((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleActSelection = (item) => {
    setSelectedAct((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleLocationSelection = (item) => {
    setSelectedLocation((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleShowAllColumns = () => {
    setColumns((prevColumns) =>
      prevColumns.map((column) => ({ ...column, visible: true }))
    );
  };

  const sortReports = (reports, sortBy) => {
    const criticalityOrder = {
      High: 3,
      Medium: 2,
      Low: 1,
    };

    return [...reports].sort((a, b) => {
      switch (sortBy) {
        case "alphaAsc":
          return a.company_name.localeCompare(b.company_name);
        case "alphaDesc":
          return b.company_name.localeCompare(a.company_name);
        case "dueAsc":
          return new Date(a.due_date || 0) - new Date(b.due_date || 0);
        case "dueDesc":
          return new Date(b.due_date || 0) - new Date(a.due_date || 0);
        case "critLowHigh":
          return (
            (criticalityOrder[a.criticality] || 0) -
            (criticalityOrder[b.criticality] || 0)
          );
        case "critHighLow":
          return (
            (criticalityOrder[b.criticality] || 0) -
            (criticalityOrder[a.criticality] || 0)
          );
        default:
          return 0;
      }
    });
  };

  const handleQuickFilter = (type) => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    switch (type) {
      case "This Month":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case "Today":
        break;
      case "Yesterday":
        start.setDate(now.getDate() - 1);
        end.setDate(now.getDate() - 1);
        break;
      case "Last 7 days":
        start.setDate(now.getDate() - 6);
        break;
      case "Last 30 days":
        start.setDate(now.getDate() - 29);
        break;
      case "Manual":
        setActiveFilter("Manual");
        return;
      default:
        return;
    }

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    setFilterDateWise({ startDate: start, endDate: end });
    setActiveFilter(type);

    applyDateFilter({ startDate: start, endDate: end });
  };

  const applyDateFilter = () => {
    if (!filterDateWise.startDate || !filterDateWise.endDate) return;

    const dateFiltered = reports.filter((item) =>
      isLocalDateInRange(item.due_date, filterDateWise.startDate, filterDateWise.endDate)
    );

    const finalFiltered = dateFiltered.filter((item) => {
      const companyMatch =
        selectedCompany.length === 0 ||
        selectedCompany.includes(item.company_name);
      const locationMatch =
        selectedLocation.length === 0 ||
        selectedLocation.includes(item.location);
      return companyMatch && locationMatch;
    });

    setIsOpen(!isOpen);
    setFilteredReports(finalFiltered);
  };

  async function getCopmlianceById(id) {
    setLoading(true);

    try {
      const { data } = await requestApi(`/report/fetch/by-auditor/${id}`, {
        method: "get",
      });

      if (data) {
        setCompliance(data);
        setShowModal(true);
      } else {
        toast.error("No data found.");
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  async function handleUpdateModal(e, id) {
    e.preventDefault();

    if (!id) {
      toast.info("Compliance ID is missing. Please try again.");
      return;
    }

    // if (
    //   !formData.accepted ||
    //   !formData.comment ||
    //   formData.comment.trim() === ""
    // ) {
    //   toast.info(
    //     "Please add a valid comment and verify the checkbox before submitting."
    //   );
    //   return;
    // }

    setLoading(true);

    try {
      const { statusCode } = await requestApi(`/report/verify-report/${id}`, {
        method: "put",
        body: JSON.stringify({
          verify_report: formData.accepted,
          comment_of_auditor: formData.comment,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (statusCode === 200) {
        toast.success("Comment updated successfully!");

        setFormData({
          accepted: "",
          comment: "",
        });
        fetchReports();
        setShowModal(false);
      }
    } catch (err) {
      toast.error(err?.data, "Failed to update comment.");
    } finally {
      setLoading(false);
    }
  }

  const sendReminderToApprover = async (approverId) => {
    if (!approverId) {
      toast.error("Approver ID not found.");
      return;
    }

    try {
      const response = await requestApi(`/auditor/send-approver-reminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ approverId }),
      });

      if (response.statusCode === 200) {
        toast.success("Documents Requested Successfully");
      } else {
        toast.error(`Failed to request documents`);
      }
    } catch (error) {
      alert("Error sending reminder. Please try again.");
      console.error("Reminder error:", error);
    }
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleRowSelect = (rowId) => {
    setSelectedRows(prev =>
      prev.includes(rowId)
        ? prev.filter(id => id !== rowId)
        : [...prev, rowId]
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === currentItems.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(currentItems.map(item => item.id));
    }
  };

  const handleBulkFormChange = (key, value) => {
    setBulkFormData(prev => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleBulkUpdate = async (e) => {
    e.preventDefault();

    if (selectedRows.length === 0) {
      toast.info("Please select at least one item.");
      return;
    }

    if (!bulkFormData.accepted || !bulkFormData.comment || bulkFormData.comment.trim() === "") {
      toast.info("Please verify the report and add a valid comment.");
      return;
    }

    setLoading(true);

    try {
      const updatePromises = selectedRows.map(id =>
        requestApi(`/report/verify-report/${id}`, {
          method: "put",
          body: JSON.stringify({
            verify_report: bulkFormData.accepted ? 1 : 0,
            comment_of_auditor: bulkFormData.comment,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        })
      );

      const results = await Promise.all(updatePromises);

      const successful = results.filter(result => result.statusCode === 200).length;
      const failed = results.length - successful;

      if (successful > 0) {
        toast.success(`Successfully updated ${successful} report(s).${failed > 0 ? ` ${failed} failed.` : ''}`);
        fetchReports();
        setShowBulkModal(false);
        setSelectedRows([]);
        setBulkFormData({
          accepted: false,
          comment: "",
        });
      } else {
        toast.error("Failed to update reports.");
      }
    } catch (err) {
      toast.error("Something went wrong during bulk update.");
    } finally {
      setLoading(false);
    }
  };

  const exportReport = (data, format, startDate, endDate) => {
    const now = new Date(); 

    let exportData = [...data];
    if (startDate && endDate) {
    exportData = exportData.filter((item) =>
      isLocalDateInRange(item.due_date, startDate, endDate)
    );
  }

    if (subBranches.length > 0) {
    exportData = exportData.filter((item) =>
      subBranches.includes(item.sub_branch)
    );
  }

    if (
      !Array.isArray(exportData) ||
      exportData.length === 0 ||
      !exportData[0]
    ) {
      toast.error("No data found for the selected period.");
      return;
    }

    const headers = {
      sr_no: "ID",
      company_name: "Entity",
      branch_id: "Branch",
      legislation_name: "Legislation",
      location: "Location",
      audited_date: "Audited Date",
      due_date: "Due Date",
      score: "Score",
      compd: "Compliance",
      provision: "Provision",
      curr: "Status",
      penalty_type: "Penalty Type",
      compliance_type: "Compliance Type",
      proof_mandatory: "Proof Mandatory",
      sub_branch: "Sub-Branch",
      summary_of_observation: "Summary of Observation",
    management_remark: "Management Remarks",
    additional_information: "Additional Information",
    knowledge_bank: "Knowledge Bank",
      period: "Date of Compliance",
      penalty_description: "Penalty Description",
      assigned_compliance_officer: "Compliance Officer",
      assigned_approver: "Approver",
      criticality: "Criticality",
      created_at: "Created At",
    };

    const formatDate = (dateStr) => {
      if (!dateStr) return "";
      const date = new Date(dateStr);
      if (isNaN(date)) return "";
      return date.toLocaleDateString("en-GB"); // dd-mm-yyyy
    };

    const formattedData = exportData.map((item) => {
      const calculateScore = (status) => {
        switch (status) {
          case "Complied":
            return "1";
          case "Partial Complied":
            return "0.5";
          case "Not Complied":
          case "Not Applicable":
            return "0";
          default:
            return "-";
        }
      };

      return {
        ID: item.id,
        Entity: item.company_name,
        Branch: item.branch_id,
        Legislation: item.legislation_name,
        Location: item.location,
        "Audited Date": formatDate(item.audited_date),
        "Due Date": formatDate(item.due_date),
        Score: calculateScore(item.curr),
        Compliance: item.compd,
        Provision: item.provision,
        Status: item.curr,
        "Summary of Observation": item.summary_of_observation,
     "Management Remarks": item.management_remark,
     "Additional Information": item.additional_information,
     "Knowledge Bank": item.knowledge_bank,
        "Penalty Type": item.penalty_type,
        "Compliance Type": item.compliance_type,
        "Proof Mandatory": item.proof_mandatory,
        "Sub-Branch": item.sub_branch,
        "Penalty Description": item.penalty_description,
        "Compliance Officer": item.assigned_compliance_officer,
        Approver: item.assigned_approver,
        Criticality: item.criticality,
        "Created At": formatDate(item.created_at),
      };
    });

const mapFormattedData = exportData.map((item, index) => {
  const mapped = {};

  for (const key in headers) {
    let val = "";

    // ✅ Serial number
    if (key === "sr_no") {
      val = index + 1;
    }
    // ✅ Score calculation
    else if (key === "score") {
      switch (item.curr) {
        case "Complied":
          val = "1";
          break;
        case "Partial Complied":
          val = "0.5";
          break;
        case "Not Complied":
        case "Not Applicable":
          val = "0";
          break;
        default:
          val = "-";
      }
    }
    // ✅ Date formatting
    else if (
      key.includes("date") ||
      key === "created_at" ||
      key === "audited_date" ||
      key === "due_date" ||
      key === "period"
    ) {
      val = formatDate(item[key]);
    }
    // ✅ Normal fields
    else {
      val = item[key] ?? "";
    }

    mapped[headers[key]] = val;
  }

  return mapped;
});


    if (format === "excel") {
      const displayHeaders = Object.values(headers);

      const uniqueCompanies = [
        ...new Set(
          mapFormattedData
            .map((item) => item["Company Name"] || item["Entity"] || item.companyName || item.company_name)
            .filter(Boolean)
        ),
      ];
      let companyNameText = "";
      if (uniqueCompanies.length > 0) {
        companyNameText = uniqueCompanies.join(", ");
      } else if (
        typeof selectedCompany !== "undefined" &&
        selectedCompany &&
        selectedCompany.length > 0
      ) {
        companyNameText = Array.isArray(selectedCompany)
          ? selectedCompany.join(", ")
          : selectedCompany;
      } else {
        companyNameText = "Company Name";
      }

      const uniqueLocations = [
        ...new Set(
          mapFormattedData
            .map((item) => item["Location"] || item.location)
            .filter(Boolean)
        ),
      ];
      let locationText = "";
      if (uniqueLocations.length > 0) {
        locationText = uniqueLocations.join(", ");
      } else if (
        typeof selectedLocation !== "undefined" &&
        selectedLocation &&
        selectedLocation.length > 0
      ) {
        locationText = Array.isArray(selectedLocation)
          ? selectedLocation.join(", ")
          : selectedLocation;
      } else {
        locationText = "All Locations";
      }

      let dateRangeText = "";
      if (
        typeof filterDateWise !== "undefined" &&
        filterDateWise &&
        filterDateWise.startDate &&
        filterDateWise.endDate
      ) {
        dateRangeText = `${formatDate(filterDateWise.startDate)} to ${formatDate(filterDateWise.endDate)}`;
      } else if (period) {
        dateRangeText = period;
      } else {
        dateRangeText = "All";
      }

      const getColumnLetter = (colIndex) => {
        let temp,
          letter = "";
        while (colIndex > 0) {
          temp = (colIndex - 1) % 26;
          letter = String.fromCharCode(65 + temp) + letter;
          colIndex = (colIndex - temp - 1) / 26;
        }
        return letter;
      };

      const totalCols = displayHeaders.length;
      const lastColLetter = getColumnLetter(totalCols);
      const totalRows = 4 + mapFormattedData.length;

      const worksheet = XLSX.utils.json_to_sheet(mapFormattedData, {
        origin: "A4",
      });

      const colWidths = displayHeaders.map((header) => ({
        wch: Math.max(String(header).length + 5, 18),
      }));
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      XlsxPopulate.fromDataAsync(wbout)
        .then((wb) => {
          const sheet = wb.sheet(0);

          // 1. Row 1: Company Name (Left Aligned)
          const companyRange = sheet.range(`A1:${lastColLetter}1`);
          companyRange.merged(true);
          sheet.cell("A1").value(`Company Name: ${companyNameText}`);
          companyRange.style({
            bold: true,
            fontSize: 14,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 2. Row 2: Location (Left Aligned)
          const locationRange = sheet.range(`A2:${lastColLetter}2`);
          locationRange.merged(true);
          sheet.cell("A2").value(`Location: ${locationText}`);
          locationRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 3. Row 3: Period (Left Aligned)
          const dateRange = sheet.range(`A3:${lastColLetter}3`);
          dateRange.merged(true);
          sheet.cell("A3").value(`Period: ${dateRangeText}`);
          dateRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 4. Headings (Row 4): bold, larger text size, text wrapping, highlighted background, borders
          sheet.range(`A4:${lastColLetter}4`).style({
            bold: true,
            fontSize: 12,
            wrapText: true,
            horizontalAlignment: "center",
            verticalAlignment: "center",
            fill: "D9E1F2",
            border: true,
          });

          // 5. Data Contents (Row 5..totalRows): text wrapping, vertical alignment, borders
          if (totalRows >= 5) {
            sheet.range(`A5:${lastColLetter}${totalRows}`).style({
              wrapText: true,
              fontSize: 10,
              verticalAlignment: "center",
              border: true,
            });
          }

          return wb.outputAsync();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          a.href = url;
          a.download = `Report_${period}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        });
    } else if (format === "pdf") {
      const newWindow = window.open();
      if (!newWindow) return;

      const tableHeaders = Object.values(headers);
      const tableRows = mapFormattedData.map(
        (item) =>
          `<tr>${tableHeaders
            .map((h) => `<td>${item[h] ?? ""}</td>`)
            .join("")}</tr>`
      );

      const htmlContent = `
      <html>
        <head>
          <title>Report</title>
          <style>
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
              table-layout: fixed;
              word-wrap: break-word;
            }
            th, td {
              border: 1px solid #000;
              padding: 4px;
              text-align: left;
            }
            th {
              background-color: #f0f0f0;
            }
              @media print {
  body {
    zoom: 50%; /* scale down for printing */
  }
}

          </style>
        </head>
        <body>
          <h2>Filtered Report - ${period}</h2>
          <table>
            <thead>
              <tr>${tableHeaders.map((h) => `<th>${h}</th>`).join("")}</tr>
            </thead>
            <tbody>${tableRows.join("")}</tbody>
          </table>
        </body>
      </html>
    `;
      newWindow.document.write(htmlContent);
      newWindow.document.close();
      newWindow.print();
    }
  };

  const formatCell = (val) => {
    if (val instanceof Date) return val.toLocaleDateString();
    if (typeof val === "string" && !isNaN(Date.parse(val))) {
      return new Date(val).toLocaleString();
    }
    return val;
  };

  const isImageFile = (fileName) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const extension = fileName.split(".").pop().toLowerCase();
    return imageExtensions.includes(extension);
  };

  const cleanFileName = (filePath) => {
    return filePath.split("/").pop();
  };

  const getFileType = (fileName) => {
    const extension = fileName.split(".").pop().toUpperCase();
    return `${extension} File`;
  };

  const renderFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    const icons = {
      pdf: "https://cdn-icons-png.flaticon.com/512/337/337946.png",
      doc: "https://cdn-icons-png.flaticon.com/512/888/888879.png",
      xls: "https://cdn-icons-png.flaticon.com/512/888/888879.png",
      default: "https://cdn-icons-png.flaticon.com/512/833/833524.png",
    };
    const icon = icons[extension] || icons.default;
    return (
      <img
        src={icon}
        alt="File icon"
        style={{ width: "32px", height: "32px", marginRight: "8px" }}
      />
    );
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <section className="lyt-section typ-min-height p-5">
      <div className=" ">
        <div className=" w-100 ">
          <div className="d-flex justify-content-between ">
            <div className="d-flex w-100 justify-content-between ">
              <div className="d-flex gap-4">
                <Dropdown
                  label="Select Company Name"
                  options={companies}
                  selectedItems={selectedCompany}
                  setSelectedItems={setSelectedCompany}
                />

                <Dropdown
                  label="Sub Branch"
                  options={subBranches}
                  selectedItems={selectedSubBranch}
                  setSelectedItems={setSelectedSubBranch}
                />

                


                <ActDropdown
                  label="Select Acts"
                  availableActs={availableActs}
                  selectedActs={selectedAct}
                  setSelectedActs={setSelectedAct}
                />

                <Dropdown
                  label="Select Locations"
                  options={locations}
                  selectedItems={selectedLocation}
                  setSelectedItems={setSelectedLocation}
                />

                <Dropdown
                          label="Select Status"
                          options={statusOptions}
                          selectedItems={selectedStatus}
                          setSelectedItems={setSelectedStatus}
                        />
                <div className="position-relative d-inline-block"  ref={dateDropdownRef}>
                  <button
                    className="btn bg-white border  border-secondary-subtle d-flex align-items-center gap-2  w-20"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                      alt="Calendar Icon"
                      width="16"
                      height="16"
                    />
                    <span className="fs-12">
                     {filterDateWise.startDate?.toLocaleDateString(
                                    "en-GB"
                                  )} - {filterDateWise.endDate?.toLocaleDateString(
                                    "en-GB"
                                  )}
                    </span>
                  </button>

                  {isOpen && (
                    <div
                      className="position-absolute mt-2 bg-white border shadow p-3"
                      style={{ zIndex: 1000, width: "50vw", right: 0 }}
                    >
                      <div className="row">
                        <div className="col-md-3">
                          <ul className="list-group fs-12">
                            {[
                              "This Month",
                              "Today",
                              "Yesterday",
                              "Last 7 days",
                              "Last 30 days",
                              "Manual",
                            ].map((label) => (
                              <li
                                key={label}
                                className={`list-group-item ${
                                  activeFilter === label
                                    ? "bg-light rounded"
                                    : ""
                                }`}
                                style={{ border: "none", cursor: "pointer" }}
                                onClick={() => handleQuickFilter(label)}
                              >
                                {label}
                              </li>
                            ))}
                          </ul>
                        </div>
                        {activeFilter === "Manual" && (
                          <div className="col-md-9 border-start">
                            <div className="row">
                              <div className="col-md-6">
                                <DatePicker
                                  selected={filterDateWise.startDate}
                                  onChange={(date) =>
                                    setFilterDateWise((prev) => ({
                                      ...prev,
                                      startDate: date,
                                    }))
                                  }
                                  inline
                                />
                              </div>
                              <div className="col-md-6">
                                <DatePicker
                                  selected={filterDateWise.endDate}
                                  onChange={(date) =>
                                    setFilterDateWise((prev) => ({
                                      ...prev,
                                      endDate: date,
                                    }))
                                  }
                                  inline
                                />
                              </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between align-items-center">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <span
                                  style={{
                                    backgroundColor: "#343a40",
                                    color: "#fff",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {filterDateWise.startDate?.toLocaleDateString(
                                    "en-GB"
                                  )}
                                </span>

                                <span
                                  style={{ fontSize: "16px", color: "#000" }}
                                >
                                  →
                                </span>

                                <span
                                  style={{
                                    backgroundColor: "#343a40",
                                    color: "#fff",
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                  }}
                                >
                                  {filterDateWise.endDate?.toLocaleDateString(
                                    "en-GB"
                                  )}
                                </span>
                              </div>
                              <button
                                className="btn btn-dark fs-12"
                                onClick={() => applyDateFilter()}
                              >
                                Apply
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="d-flex gap-4">
                {selectedRows.length > 0 && !selectedRows.some(id => {
                  const report = currentItems.find(item => item.id === id);
                  return report && report.verify_report === 1;
                }) && (
                  <button
                    className="btn bg-white border border-secondary-subtle d-flex align-items-center justify-content-center shadow-sm gap-2 fh"
                    onClick={() => setShowBulkModal(true)}
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #E4E4E7",
                      color: "#1F1F23",
                      fontWeight: 500,
                      padding: "6px 12px",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>
                    </svg>
                    Bulk Update ({selectedRows.length})
                  </button>
                )}
                <div className="">
                  <button
                    class="btn bg-white border border-secondary-subtle d-flex align-items-center justify-content-center shadow-sm gap-2 fh"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3 3h10v1H3V3zm0 3h7v1H3V6zm0 3h4v1H3V9zm8 2h3v-3h1v3h3l-3.5 3.5L11 11z" />
                    </svg>
                  </button>

                  <ul
                    className="dropdown-menu shadow-sm"
                    style={{ minWidth: "180px", fontSize: "12px" }}
                  >
                    <li>
                      <span
                        onClick={() => setSortBy("alphaDesc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Reverse Alphabetical{" "}
                        <small className="text-muted fs-12">Z–A</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("alphaAsc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Alphabetical{" "}
                        <small className="text-muted fs-12">A–Z</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("dueAsc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Due Date - Ascending{" "}
                        <small className="text-muted fs-12">Oldest</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("dueDesc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Due Date - Descending{" "}
                        <small className="text-muted fs-12">Newest</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("critHighLow")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Criticality{" "}
                        <small className="text-danger fs-12">High–Low</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("critLowHigh")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Criticality{" "}
                        <small className="text-success fs-12">Low–High</small>
                      </span>
                    </li>
                  </ul>
                </div>

              
                <div className="position-relative" ref={dropdownRef1}>
                  <button
                    className="btn bg-white border border-secondary-subtle d-flex align-items-center justify-content-center shadow-sm gap-2 fh"
                    onClick={() => setIsOpen4(!isOpen4)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path d="M4 3h2v10H4V3zm3 0h2v10H7V3zm3 0h2v10h-2V3z" />
                    </svg>
                  </button>

                  {isOpen4 && (
                    <div
                      className="dropdown-menu show p-2 shadow-sm bg-white"
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: -110,
                        width: "250px",
                        borderRadius: "5px",
                        fontSize: "12px",
                        zIndex: 9999,
                      }}
                    >
                      <div className="fw-bold text-muted p-2 bg-light fs-12">
                        Default View
                      </div>

                      <div className="d-flex justify-content-between py-1 border-bottom bg-light">
                        <span className="fw-bold fs-12">Hidden</span>
                        <span
                          className="text-primary fs-12"
                          style={{ cursor: "pointer" }}
                          onClick={handleShowAllColumns}
                        >
                          Show all
                        </span>
                      </div>

                      <ul className="list-unstyled px-2 fs-12">
          {columns.map((col, index) => (
            <li key={col.id} className="d-flex align-items-center py-1">
              <input
                type="checkbox"
                className="me-2"
                checked={col.visible}
                onChange={() =>
                  setColumns(
                    columns.map((c, i) =>
                      i === index ? { ...c, visible: !c.visible } : c
                    )
                  )
                }
              />
              {col.label}
            </li>
          ))}
        </ul>                   

                     
                    </div>
                  )}
                </div>

                <div className="dropdown " ref={dropdownRef2}>
                  <button
                    className="btn bg-white border border-secondary-subtle d-flex align-items-center justify-content-center shadow-sm gap-2 fh"
                       onClick={toggleDropdown1}
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #E4E4E7",
                      color: "#1F1F23",
                      fontWeight: 500,
                      padding: "6px 6px",
                    }}
                  >
                    <img
                      src={exportIcon}
                      alt="Export Icon"
                      width="16"
                      height="16"
                      fontSize="12px"
                    />
                    Export
                  </button>

                  {showDropdown1 && (
                    <div
                      className="card shadow-sm position-absolute mt-2 end-0"
                      style={{
                        width: "200px",
                        zIndex: 9999,
                        transform: "translateX(10px)",
                      }}
                    >
                      <div>
                        <label className="bg-light py-1 px-2 w-100 fs-12">
                          Format
                        </label>
                        <div className="btn-group w-100 mt-2 px-2">
                          {formats.map((f) => (
                            <button
                              key={f.value}
                              className={`btn ${
                                format === f.value
                                  ? "btn-dark"
                                  : "btn-outline-dark"
                              }`}
                              onClick={() => setFormat(f.value)}
                            >
                              <i className={`bi ${f.icon}`}></i> {f.label}
                            </button>
                          ))}
                        </div>
                      </div>
                      
                      <div className="d-flex justify-content-end">
                        <button
                          className="btn btn-dark w-50 mt-3 mb-2 mx-2 fs-12  "
                          onClick={() =>
                            exportReport(filteredReports, format)
                          }
                        >
                          Exp
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div className="">
          <div className="card-body ">
            <div className="table-scroll">
              <table className="table table-hover align-middle mt-0 rounded vertical-border ">
                <thead className="bg-light text-nowrap fs-12 table-color">
            <tr>

              {columns.map(
                (col) =>
                  col.visible && (
                    <th key={col.id}>
                      {col.id === "select" ? (
                        <input
                          type="checkbox"
                          checked={selectedRows.length === currentItems.length && currentItems.length > 0}
                          onChange={handleSelectAll}
                        />
                      ) : (
                        col.label
                      )}
                    </th>
                  )
              )}
            </tr>
          </thead>
                <tbody className="fs-12 table-color">
            {Array.isArray(currentItems) && currentItems.length > 0 ? (
              currentItems.map((key, i) => (
                <tr key={i} className={selectedRows.includes(key.id) ? "table-active" : ""}>

                  {columns.map(
                    (col) =>
                      col.visible && (
                        <td key={col.id + 1}>
                          {/* Special cases */}
                          {col.id === "select" ? (
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(key.id)}
                              onChange={() => handleRowSelect(key.id)}
                            />
                          ) : col.id === "srno" ? (
                            i + 1
                          ) : col.id === "branch" ? (
                            <span style={{ color: "#0d6efd" }}>
                              {key?.branch_id || "NA"}
                            </span>
                          ) : col.id === "date_of_comp" ? (
                            key?.period
                              ? new Date(key.period)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                  .replace(/ (\w{3}) /, " $1, ")
                              : "NA"
                          ) : col.id === "due_date" ? (
                            key?.due_date ? (() => {
                              const dueDate = new Date(key.due_date);
                              const today = new Date();
                              const diffTime = dueDate - today;
                              let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                              if (diffDays < 0) diffDays = 0;

                              const formattedDate = dueDate
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .replace(/ (\w{3}) /, " $1, ");

                              let blinkClass = "blink ";
                              blinkClass += diffDays > 0 ? "text-green-600" : "text-red-600";

                              return (
                                <span>
                                  {formattedDate}{" "}
                                  <span className={blinkClass}>
                                    ({diffDays} days to go)
                                  </span>
                                </span>
                              );
                            })() : "NA"
                          ) : col.id === "status" ? (
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                backgroundColor:
                                  key.curr === "Complied"
                                    ? "#d1fae5"
                                    : key.curr === "Partial Complied"
                                    ? "#fef9c3"
                                    : key.curr === "Not Complied"
                                    ? "#fee2e2"
                                    : key.curr === "Not Applicable"
                                    ? "#f3f4f6"
                                    : "#ffe8dc",
                                color:
                                  key.curr === "Complied"
                                    ? "#065f46"
                                    : key.curr === "Partial Complied"
                                    ? "#92400e"
                                    : key.curr === "Not Complied"
                                    ? "#991b1b"
                                    : key.curr === "Not Applicable"
                                    ? "#6b7280"
                                    : "#9a3412",
                                border:
                                  key.curr === "Complied"
                                    ? "1px solid #10b981"
                                    : key.curr === "Partial Complied"
                                    ? "1px solid #facc15"
                                    : key.curr === "Not Complied"
                                    ? "1px solid #ef4444"
                                    : key.curr === "Not Applicable"
                                    ? "1px solid #d1d5db"
                                    : "1px solid #f9964bff",
                                borderRadius: "4px",
                                padding: "3px 10px",
                                fontSize: "10px",
                                fontWeight: "500",
                              }}
                            >
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "8px",
                                  height: "8px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    key.curr === "Complied"
                                      ? "#10b981"
                                      : key.curr === "Partial Complied"
                                      ? "#facc15"
                                      : key.curr === "Not Complied"
                                      ? "#ef4444"
                                      : key.curr === "Not Applicable"
                                      ? "#9ca3af"
                                      : "#f9964bff",
                                  marginRight: "8px",
                                }}
                              ></span>
                              {key.curr || "Unknown"}
                            </div>
                          ) : col.id === "action" ? (
                            key.verify_report === 1 ? (
                              <>
                                <button
                                  style={{
                                    backgroundColor: "#10b981",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "4px",
                                    padding: "6px 12px",
                                    fontWeight: "500",
                                    fontSize: "14px",
                                    cursor: "default",
                                  }}
                                  disabled
                                >
                                  Verified
                                </button>
                                <a
                                  onClick={() => getCopmlianceById(Number(key.id))}
                                  style={{
                                    marginLeft: "8px",
                                    color: "#0d6efd",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    fontSize: "13px",
                                  }}
                                  
                                >
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil"
                                      viewBox="0 0 16 16"
                                    >
                                      <path
                                        d="M12.146.146a.5.5 0 0 1 .708 0l3 
             3a.5.5 0 0 1 0 .708l-10 10a.5.5 
             0 0 1-.168.11l-5 2a.5.5 0 0 
             1-.65-.65l2-5a.5.5 0 0 
             1 .11-.168l10-10zM11.207 
             2L13 3.793 14.793 2 13 
             .207 11.207 2zM12 4L10 2 
             3 9v2h2l7-7z"
                                      />
                                    </svg>
                                </a>
                              </>
                            ) : (
                              <a
                                onClick={() => getCopmlianceById(Number(key.id))}
                                style={{
                                  color: "#0d6efd",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                  fontWeight: "500",
                                  fontSize: "10px",
                                }}
                              >
                                Verify Report
                              </a>
                            )
                          ) : (
                            key[col.key] ?? "NA"
                          )}
                        </td>
                      )
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan="13"
                  style={{
                    textAlign: "center",
                    padding: "12px",
                    color: "#6c757d",
                  }}
                >
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
              </table>
              {(showModal || loading) && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                    style={{ maxWidth: "800px", width: "100%" }}
                  >
                    <div
                      className="modal-content p-4"
                      style={{ borderRadius: "12px" }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="modal-title"></h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={(e) => {
                            e.preventDefault();
                            setShowModal(false);
                            setFormData({
                              accepted: "",
                              comment: "",
                            });
                          }}
                        />
                      </div>
                      <form
                        onSubmit={(e) => handleUpdateModal(e, compliance?.id)}
                      >
                        <div>
                          <h4 className="fs-12">
                            Compliance Action{" "}
                            {/* <span
                              style={{
                                display: "inline-block",
                                padding: "2px 8px",
                                backgroundColor: "#f3f4f6",
                                color: "#1f2937",
                                borderRadius: "12px",
                                fontSize: "12px",
                                fontWeight: "500",
                                boxShadow: "0 0 0 1px #d1d5db",
                              }}
                            >
                              {compliance?.provision}
                            </span> */}
                          </h4>
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Compliance Description:{" "}
                            </strong>
                            {compliance?.compliance || "NA"}
                          </p>

                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Legislation :{" "}
                            </strong>
                            {compliance?.legislation.legislation_name || "NA"}
                          </p>
                          <strong className="fs-12">Select Status</strong>
                          <br />
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              backgroundColor:
                                compliance?.current_compliance_status ===
                                "Complied"
                                  ? "#d1fae5"
                                  : compliance?.current_compliance_status ===
                                    "Partial Complied"
                                  ? "#fef9c3"
                                  : compliance?.current_compliance_status ===
                                    "Not Complied"
                                  ? "#fee2e2"
                                  : compliance?.current_compliance_status ===
                                    "Not Applicable"
                                  ? "#e0f2fe"
                                  : "#ffe8dc", // fallback (light orange)
                              color:
                                compliance?.current_compliance_status ===
                                "Complied"
                                  ? "#065f46"
                                  : compliance?.current_compliance_status ===
                                    "Partial Complied"
                                  ? "#92400e"
                                  : compliance?.current_compliance_status ===
                                    "Not Complied"
                                  ? "#991b1b"
                                  : compliance?.current_compliance_status ===
                                    "Not Applicable"
                                  ? "#1e40af"
                                  : "#9a3412", // fallback (dark orange)
                              border:
                                compliance?.current_compliance_status ===
                                "Complied"
                                  ? "1px solid #10b981"
                                  : compliance?.current_compliance_status ===
                                    "Partial Complied"
                                  ? "1px solid #facc15"
                                  : compliance?.current_compliance_status ===
                                    "Not Complied"
                                  ? "1px solid #ef4444"
                                  : compliance?.current_compliance_status ===
                                    "Not Applicable"
                                  ? "1px solid #3b82f6"
                                  : "1px solid #f9964bff", // fallback (orange)
                              borderRadius: "4px",
                              padding: "4px 12px",
                              fontSize: "12px",
                              fontWeight: "500",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "8px",
                                height: "8px",
                                backgroundColor:
                                  compliance?.current_compliance_status ===
                                  "Complied"
                                    ? "#10b981"
                                    : compliance?.current_compliance_status ===
                                      "Partial Complied"
                                    ? "#facc15"
                                    : compliance?.current_compliance_status ===
                                      "Not Complied"
                                    ? "#ef4444"
                                    : compliance?.current_compliance_status ===
                                      "Not Applicable"
                                    ? "#3b82f6"
                                    : "#f9964bff", // fallback (orange)
                                borderRadius: "50%",
                                marginRight: "8px",
                              }}
                            ></span>
                            {compliance?.current_compliance_status || "NA"}
                          </div>

                          <div className="mb-3">
                            <label className="form-label fw-semibold fs-12">
                              Attached Proof
                            </label>
                            {compliance?.proof_file &&
                            compliance.proof_file !== "" ? (
                              <div
                                className="border p-2 rounded bg-light mt-2"
                                style={{ fontSize: "12px", width: "300px" }}
                              >
                                {!isImageFile(compliance.proof_file) ? (
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="d-flex align-items-center">
                                      {renderFileIcon(compliance.proof_file)}
                                      <div className="ml-2">
                                        <div>
                                          <strong>
                                            {cleanFileName(
                                              compliance.proof_file
                                            )}
                                          </strong>
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            color: "#888",
                                          }}
                                        >
                                          {getFileType(compliance.proof_file)}
                                        </div>
                                      </div>
                                    </div>
                                    <a
                                      href={`${API_URL}/${compliance.proof_file}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-sm btn-dark"
                                      style={{ fontSize: "10px" }}
                                    >
                                      View
                                    </a>
                                  </div>
                                ) : (
                                  <img
                                    src={`${API_URL}/${compliance.proof_file}`}
                                    alt="Proof File"
                                    style={{
                                      width: "100%",
                                      maxHeight: "150px",
                                      objectFit: "contain",
                                      borderRadius: "8px",
                                      backgroundColor: "#f0f0f0",
                                    }}
                                    className="mt-2"
                                  />
                                )}
                              </div>
                            ) : (
                              <div className="fw-normal text-dark fs-12">
                                NA
                              </div>
                            )}
                          </div>
                          <div>
                            <label className="text-xs font-medium fs-12">
                              Attached Proof Link
                            </label>
                          </div>
                          {compliance?.proofs_link &&
                          compliance.proofs_link !== "NA" ? (
                            <a
                              href={encodeURI(compliance.proofs_link)}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {compliance.proofs_link}
                            </a>
                          ) : (
                            <span className="fs-12">NA</span>
                          )}

                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "16px",
                              paddingTop: "16px",
                            }}
                          >
                            <div
                              style={{
                                flex: "1 1 45%",
                                minWidth: "280px",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#1f2937",
                                  marginBottom: "4px",
                                }}
                              >
                                Compliancer Officer Comment
                              </h4>
                              <p
                                style={{
                                  fontSize: "14px",
                                  color: "#4b5563",
                                }}
                              >
                                {compliance?.comment_of_officer || "NA"}
                              </p>
                            </div>
                            <div
                              style={{
                                flex: "1 1 45%",
                                minWidth: "280px",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#1f2937",
                                  marginBottom: "4px",
                                }}
                              >
                                Compliancer Officer Description
                              </h4>
                              <p
                                style={{
                                  fontSize: "12px",
                                  color: "#4b5563",
                                }}
                              >
                                {compliance?.compliance_description || "NA"}
                              </p>
                            </div>
                          </div>
                          <div
                            style={{
                              backgroundColor: "#f9fafb",
                              padding: "16px",
                              borderRadius: "8px",
                              marginTop: "16px",
                            }}
                          >
                            <div style={{ marginBottom: "16px" }}>
                              <label
                                htmlFor="verifyToggle"
                                style={{
                                  fontWeight: "500",
                                  fontSize: "12px",
                                  marginRight: "12px",
                                  color: "#111827",
                                }}
                              >
                                Verify Report
                              </label>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <label
  htmlFor="toggleSwitch"
  style={{
    display: "inline-block",
    width: "48px",
    height: "24px",
    backgroundColor: formData.accepted ? "#343434" : "#d1d5db",
    borderRadius: "9999px",
    position: "relative",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
  }}
>
                                  <input
                                    type="checkbox"
                                    id="toggleSwitch"
                                    name="accepted"
                                    checked={formData.accepted}
                                    onChange={(e) =>
                                      handleChange(
                                        e.target.name,
                                        e.target.checked ? 1 : 0
                                      )
                                    }
                                    style={{
                                      display: "none",
                                    }}
                                  />

                                  <span
    style={{
      position: "absolute",
      top: "2px",
      left: formData.accepted ? "26px" : "2px",
      width: "20px",
      height: "20px",
      backgroundColor: "#fff",
      borderRadius: "50%",
      transition: "left 0.3s ease",
      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
    }}
  />
                                </label>
                                {compliance?.verify_report === 1 && (
                                  <button
                                    type="submit"
                                    style={{
                                      backgroundColor: "#1f2937",
                                      color: "white",
                                      padding: "8px 20px",
                                      fontSize: "12px",
                                      borderRadius: "6px",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Submit
                                  </button>
                                )}
                              </div>
                            </div>

                            {compliance?.verify_report === 0 && (
                              <>
                                <div style={{ marginBottom: "16px" }}>
                                  <label
                                    htmlFor="comment"
                                    style={{
                                      display: "block",
                                      fontWeight: "500",
                                      fontSize: "12px",
                                      color: "#111827",
                                      marginBottom: "6px",
                                    }}
                                  >
                                    Comment
                                  </label>
                                  <textarea
                                    id="comment"
                                    name="comment"
                                    placeholder="Enter here"
                                    rows="4"
                                    style={{
                                      width: "100%",
                                      padding: "12px",
                                      border: "1px solid #e5e7eb",
                                      borderRadius: "8px",
                                      fontSize: "12px",
                                      color: "#374151",
                                      resize: "vertical",
                                    }}
                                    value={formData.comment}
                                    onChange={(e) =>
                                      handleChange(
                                        e.target.name,
                                        e.target.value
                                      )
                                    }
                                  />
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={() =>
                                      sendReminderToApprover(
                                        compliance?.report
                                          ?.assigned_compliance_officer_id
                                      )
                                    }
                                    style={{
                                      backgroundColor: "#1d4ed8",
                                      color: "#fff",
                                      padding: "8px 16px",
                                      fontSize: "12px",
                                      borderRadius: "6px",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Request Documents
                                  </button>
                                  <button
                                    type="submit"
                                    style={{
                                      backgroundColor: "#1f2937",
                                      color: "white",
                                      padding: "8px 20px",
                                      fontSize: "12px",
                                      borderRadius: "6px",
                                      border: "none",
                                      cursor: "pointer",
                                    }}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}

              {/* Bulk Update Modal */}
              {showBulkModal && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                    style={{ maxWidth: "600px", width: "100%" }}
                  >
                    <div
                      className="modal-content p-4"
                      style={{ borderRadius: "12px" }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="modal-title">Bulk Verify Reports</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => {
                            setShowBulkModal(false);
                            setBulkFormData({ accepted: false, comment: "" });
                          }}
                        />
                      </div>
                      <p className="text-muted mb-3">
                        You are about to verify {selectedRows.length} report(s). Please provide a comment for all selected reports.
                      </p>
                      <form onSubmit={handleBulkUpdate}>
                        <div
                          style={{
                            backgroundColor: "#f9fafb",
                            padding: "16px",
                            borderRadius: "8px",
                            marginBottom: "16px",
                          }}
                        >
                          <div style={{ marginBottom: "16px" }}>
                            <label
                              htmlFor="bulkVerifyToggle"
                              style={{
                                fontWeight: "500",
                                fontSize: "12px",
                                marginRight: "12px",
                                color: "#111827",
                              }}
                            >
                              Verify Report
                            </label>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <label
                                htmlFor="bulkToggleSwitch"
                                style={{
                                  display: "inline-block",
                                  width: "48px",
                                  height: "24px",
                                  backgroundColor: bulkFormData.accepted ? "#343434" : "#d1d5db",
                                  borderRadius: "9999px",
                                  position: "relative",
                                  cursor: "pointer",
                                  transition: "background-color 0.3s ease",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  id="bulkToggleSwitch"
                                  name="accepted"
                                  checked={bulkFormData.accepted}
                                  onChange={(e) =>
                                    handleBulkFormChange(
                                      e.target.name,
                                      e.target.checked
                                    )
                                  }
                                  style={{
                                    display: "none",
                                  }}
                                />

                                <span
                                  style={{
                                    position: "absolute",
                                    top: "2px",
                                    left: bulkFormData.accepted ? "26px" : "2px",
                                    width: "20px",
                                    height: "20px",
                                    backgroundColor: "#fff",
                                    borderRadius: "50%",
                                    transition: "left 0.3s ease",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                                  }}
                                />
                              </label>
                            </div>
                          </div>

                          <div style={{ marginBottom: "16px" }}>
                            <label
                              htmlFor="bulkComment"
                              style={{
                                display: "block",
                                fontWeight: "500",
                                fontSize: "12px",
                                color: "#111827",
                                marginBottom: "6px",
                              }}
                            >
                              Comment *
                            </label>
                            <textarea
                              id="bulkComment"
                              name="comment"
                              placeholder="Enter comment for all selected reports"
                              rows="4"
                              style={{
                                width: "100%",
                                padding: "12px",
                                border: "1px solid #e5e7eb",
                                borderRadius: "8px",
                                fontSize: "12px",
                                color: "#374151",
                                resize: "vertical",
                              }}
                              value={bulkFormData.comment}
                              onChange={(e) =>
                                handleBulkFormChange(
                                  e.target.name,
                                  e.target.value
                                )
                              }
                              required
                            />
                          </div>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => {
                              setShowBulkModal(false);
                              setBulkFormData({ accepted: false, comment: "" });
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                          >
                            {loading ? "Updating..." : `Verify ${selectedRows.length} Report(s)`}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <select
            className="form-select form-select-sm w-auto"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            {[10, 20, 30, 50].map((size) => (
              <option key={size} value={size} className="fs-12">
                {size} per page
              </option>
            ))}
          </select>
        </div>
        <nav>
          <ul className="pagination mb-0 d-flex align-items-center gap-2">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link text-dark border-0 bg-transparent fs-12"
                onClick={handlePrevious}
              >
                Previous
              </button>
            </li>
            {startPage > 1 && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}
            {pageNumbers.map((pageNum) => (
              <li
                key={pageNum}
                className={`page-item ${
                  currentPage === pageNum ? "active" : ""
                }`}
              >
                <button
                  key={pageNum}
                  className={`page-link d-flex align-items-center justify-content-center rounded-circle mx-1 circle ${
                    currentPage === pageNum
                      ? "bg-dark text-white fw-bold border-0"
                      : "text-dark bg-white border border-secondary"
                  }`}
                  
                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            ))}
            {endPage < totalPages && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}

            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link text-dark border-0 bg-transparent fs-12"
                onClick={handleNext}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}
export default Active;
